<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 28 28"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="0.5" y="0.5" width="27" height="27" rx="7.5" fill="#494949" />
  <rect x="0.5" y="0.5" width="27" height="27" rx="7.5" stroke="#F6F6F6" />
  <path
    d="M15.9992 19.28L11.6526 14.9333C11.1392 14.42 11.1392 13.58 11.6526 13.0667L15.9992 8.72"
    fill="#FDFDFD"
  />
</svg>
